import { AppService } from '@services/app/app.service';
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

/**
 * Add the template content to the DOM unless the condition is true.
 */
@Directive({ selector: '[appIfDriver]' })
export class IfDriverDirective {
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private appService: AppService
  ) {}

  @Input() set appIfDriver(condition: [string, string, any?]) {
    const enabled = this.appService.isDriverEnabled(
      condition[0],
      condition[1],
      condition[2]
    );

    if (enabled && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!enabled && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
